import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CalendarIcon, ChevronDownIcon, CheckIcon } from 'lucide-react';
interface Period {
  id: string;
  label: string;
  month: string;
  year: string;
}
const periods: Period[] = [{
  id: '2023-07',
  label: 'Julio',
  month: '07',
  year: '2023'
}, {
  id: '2023-06',
  label: 'Junio',
  month: '06',
  year: '2023'
}, {
  id: '2023-05',
  label: 'Mayo',
  month: '05',
  year: '2023'
}, {
  id: '2023-04',
  label: 'Abril',
  month: '04',
  year: '2023'
}, {
  id: '2023-03',
  label: 'Marzo',
  month: '03',
  year: '2023'
}, {
  id: '2023-02',
  label: 'Febrero',
  month: '02',
  year: '2023'
}];
const PeriodSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(periods[0]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleSelectPeriod = (period: Period) => {
    setSelectedPeriod(period);
    setIsOpen(false);
  };
  return <div className="relative" ref={dropdownRef} data-id="element-155">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center space-x-2 px-3 py-2 bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors" data-id="element-156">
        <CalendarIcon size={18} className="text-gray-600" data-id="element-157" />
        <div className="text-left hidden md:block" data-id="element-158">
          <p className="text-sm font-medium text-gray-900" data-id="element-159">
            {selectedPeriod.label}
          </p>
          <p className="text-xs text-gray-500" data-id="element-160">{selectedPeriod.year}</p>
        </div>
        <ChevronDownIcon size={16} className={`text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-161" />
      </button>
      <AnimatePresence data-id="element-162">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.2
      }} className="absolute top-full mt-2 right-0 w-56 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden z-50" data-id="element-163">
            <div className="p-2" data-id="element-164">
              <p className="text-xs font-semibold text-gray-500 uppercase px-3 py-2" data-id="element-165">
                Seleccionar período
              </p>
              <div className="space-y-1" data-id="element-166">
                {periods.map(period => <button key={period.id} onClick={() => handleSelectPeriod(period)} className="w-full flex items-center justify-between px-3 py-2 rounded-md hover:bg-gray-50 transition-colors" data-id="element-167">
                    <div className="flex items-center space-x-3" data-id="element-168">
                      <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center" data-id="element-169">
                        <CalendarIcon size={16} className="text-blue-600" data-id="element-170" />
                      </div>
                      <span className="text-sm font-medium text-gray-900" data-id="element-171">
                        {period.label}
                      </span>
                    </div>
                    {selectedPeriod.id === period.id && <CheckIcon size={16} className="text-blue-600" data-id="element-172" />}
                  </button>)}
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export default PeriodSelector;